import SeoServicePage from "@/pages/services/SeoServicePage";

const InvisalignPage = () => (
  <SeoServicePage
    slugOverride="invisalign-cost-kalyan"
    canonicalOverride="/invisalign-kalyan"
    breadcrumbsOverride={[
      { label: "Advanced Treatments", path: "/services" },
      { label: "Invisalign Kalyan" },
    ]}
  />
);

export default InvisalignPage;